import { HelmetProvider } from './components/HelmetProvider';


export { Helmet } from 'react-helmet-async';

export const helmet = {
    renderChain: [
        [HelmetProvider, 50],
    ],
};
